import { render, staticRenderFns } from "./GetAllBlogCategories.vue?vue&type=template&id=06bcea03&"
import script from "./GetAllBlogCategories.vue?vue&type=script&lang=js&"
export * from "./GetAllBlogCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports